module.exports = __webpack_public_path__ + "question_mark.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/question_mark.png
// module id = 1913
// module chunks = 0